import { render, staticRenderFns } from "./list-exchange-reject-form.vue?vue&type=template&id=06741dda&"
import script from "./list-exchange-reject-form.vue?vue&type=script&lang=js&"
export * from "./list-exchange-reject-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports